import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {FormEventService} from '../../../../services/formEventService';
import {MatSelectChange} from '@angular/material/select';
import {FormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IBomProducts, IHttpReturnParam, IHttpSetting} from '../../../../interface/dataset-params';
import {GlobalObjectService} from '../../../../class/global-obj';
import {HttpFormDataService} from '../../../../services/services';

@Component({
    selector: 'noos-bompart',
    templateUrl: './bompart.component.html',
    styleUrls: ['./bompart.component.scss']
})
@NoosFormTypeService.register('bompart')
export class BompartComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    setting: IHttpSetting;
    itemData: IBomProducts[] = [];

    constructor(private httpService: HttpFormDataService, private eventListenerService: FormEventService) {
        this.setting = GlobalObjectService.getVar('setting');
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        console.log(this.prop.options);

        const outData = GlobalObjectService.getVar('outData_' + this.formId.toString());
        if (outData && outData.form_data!==null && outData.form_data!==undefined  && outData.form_data.length>0) {
            const findMe = outData.form_data.filter(ff => ff.name === this.prop.name);
            if (findMe.length > 0) {
                this.prop.defaultValue = findMe[0].value;
                this.prop.defaultValueTitle = findMe[0].title;
            }
        }
        this.httpService.partProducts(this.setting, this.prop.options.part_id).subscribe(ret => {
            if (ret.complete) {
                this.itemData = ret.data;
                const defaultProduct = this.itemData.filter(x => x.is_default);
                if (defaultProduct.length > 0 && this.prop.defaultValue==='') {
                    this.prop.defaultValue = defaultProduct[0].product_id;
                    this.prop.defaultValueTitle = defaultProduct[0].product_name;
                }
            }
        });
    }

    onSelect($event: MatSelectChange) {
        if (this.prop.defaultValue) {
            const findProduct = this.itemData.filter(x => x.product_id === this.prop.defaultValue);
            if (findProduct.length > 0) {
                this.prop.defaultValueTitle = findProduct[0].product_name;
            }
        }
        this.eventListenerService.updatedDataSelection({
            fromComponentId: this.prop.id,
            fromComponentName: this.prop.name,
            eventName: 'select',
            triggerValue: $event.value,
            formId: this.formId,
            datasetId: this.datasetId
        });
    }

}
